import jwtDecode from "jwt-decode";
import router from "@/router";
import { initState } from "./index";
import refreshToken from "@/services/refreshToken";
import getSPUser from "@/services/getSPUser";

const AUTH_TOKEN = process.env.VUE_APP_AUTH_TOKEN_NAME;
const SP_HOST = process.env.VUE_APP_SP_HOST;
const { VUE_APP_SP_HOST, VUE_APP_SP_SITE_URL } = process.env;

const URL_LOGIN_APP = `https://${VUE_APP_SP_HOST}/${VUE_APP_SP_SITE_URL}/login`;
let msTokenTimeOutId = null;
let ictTokenTimeOutId = null;

export default {
  login: ({ commit, dispatch }, payload) => {
    localStorage.setItem(AUTH_TOKEN, payload);
    const jwtExpDecode = jwtDecode(payload);
    dispatch("initMsToken", payload);
    commit("setAuth", jwtExpDecode);
    dispatch("checkTimeout", jwtExpDecode.exp);
    // so sánh user với SP
    if (SP_HOST) {
      dispatch("checkCurrentUserEmailEqualSPUser", jwtExpDecode);
    }
  },
  logout: ({ commit }) => {
    localStorage.removeItem(AUTH_TOKEN);
    commit("setAuth", initState);
    window.location.replace(
      `https://${VUE_APP_SP_HOST}/${VUE_APP_SP_SITE_URL}/logout/?full=true`
    );
  },
  // Payload: timeout
  checkTimeout: ({ dispatch }, payload) => {
    if (ictTokenTimeOutId) {
      clearTimeout(ictTokenTimeOutId);
    }
    const now = new Date();
    const expirationDate = new Date(payload * 1000);
    const expirationTime = expirationDate.getTime() - now.getTime();
    // if (expirationTime <= 0) {
    //   router.push("/auth/login");
    //   return;
    // }
    ictTokenTimeOutId = setTimeout(() => {
      dispatch("logout");
    }, expirationTime);
  },
  init: ({ dispatch, state }) => {
    const token = localStorage.getItem(AUTH_TOKEN) || state?.token;
    if (token) {
      dispatch("login", token);
    } else {
      // dispatch("logout");
      // router.push("/auth/login");
      window.location.replace(`${URL_LOGIN_APP}/?to=${window.location.href}`);
    }
  },
  /**
   * MS TOKEN
   */
  // Payload: timeout
  checkTimeoutMsToken: ({ dispatch }, payload) => {
    if (msTokenTimeOutId) {
      clearTimeout(msTokenTimeOutId);
    }
    const now = new Date();
    const expirationDate = new Date(payload * 1000);

    const timeLeft = expirationDate.getTime() - now.getTime();

    if (timeLeft && timeLeft > 10) {
      msTokenTimeOutId = setTimeout(() => {
        dispatch("initMsToken", localStorage.getItem(AUTH_TOKEN));
      }, timeLeft);
    }
  },
  initMsToken: async ({ dispatch, commit }, payload) => {
    if (payload) {
      try {
        // Send a POST request
        const { data } = await refreshToken(payload);
        console.log("initMsToken > hasNewMsToken", data);
        if (data?.data?.refreshMsToken) {
          // set msToken
          commit("setMsToken", data.data.refreshMsToken);
          // call check timeout
          const jwtExpDecode = jwtDecode(data.data.refreshMsToken);
          dispatch("checkTimeoutMsToken", jwtExpDecode.exp);
        } else {
          console.log("> Lỗi get new refreshToken");
          // dispatch("logout");
        }
      } catch (error) {
        console.log("> Lỗi refreshToken", error);
      }
    } else {
      // dispatch("logout");
      router.push("/auth/login");
    }
  },
  // Kiểm tra nếu user SP !== user Graph thì logout
  checkCurrentUserEmailEqualSPUser: async ({ dispatch }, payload) => {
    try {
      const { data } = await getSPUser();
      if (data?.d?.Email) {
        if (data.d.Email !== payload.email?.toString()) {
          localStorage.removeItem(AUTH_TOKEN);
          window.location.replace(
            `${URL_LOGIN_APP}/?to=${window.location.href}`
          );
        }
      }
    } catch (error) {
      console.log("Error checkCurrentUserEmailEqualSPUser: ", error);
    }
  },
};
